import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFacebookSocial = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 6C2.25 3.92893 3.92893 2.25 6 2.25H18C20.0711 2.25 21.75 3.92893 21.75 6V18C21.75 20.0711 20.0711 21.75 18 21.75H13.5V15H16.0995L16.3852 13H13.5V10.25C13.5 9.2835 14.2835 8.5 15.25 8.5H16.5V6.5H14.75C12.9551 6.5 11.5 7.95507 11.5 9.75V13H9.5V15H11.5V21.75H6C3.92893 21.75 2.25 20.0711 2.25 18V6ZM6 3.75C4.75736 3.75 3.75 4.75736 3.75 6V18C3.75 19.2426 4.75736 20.25 6 20.25H10V16.5H9.25C8.55964 16.5 8 15.9404 8 15.25V12.75C8 12.0596 8.55964 11.5 9.25 11.5H10V9.75C10 7.12665 12.1266 5 14.75 5H16.75C17.4404 5 18 5.55964 18 6.25V8.75C18 9.44036 17.4404 10 16.75 10H15.25C15.1119 10 15 10.1119 15 10.25V11.5H16.6735C17.4342 11.5 18.0185 12.1737 17.9109 12.9268L17.5538 15.4268C17.4658 16.0426 16.9384 16.5 16.3164 16.5H15V20.25H18C19.2426 20.25 20.25 19.2426 20.25 18V6C20.25 4.75736 19.2426 3.75 18 3.75H6Z",
		fill: "currentColor"
	})
});
export { SvgIconFacebookSocial as ReactComponent };
